import { render, staticRenderFns } from "./LocationsDataTable.vue?vue&type=template&id=71deaf54&scoped=true"
import script from "./LocationsDataTable.vue?vue&type=script&lang=js"
export * from "./LocationsDataTable.vue?vue&type=script&lang=js"
import style0 from "./LocationsDataTable.vue?vue&type=style&index=0&id=71deaf54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71deaf54",
  null
  
)

export default component.exports